/**
 * DialInput component.
 */
import Colors from '@shared/assets/style/default/color';
import Fonts from '@shared/assets/style/default/fonts';
import Screen from '@shared/utils/screen';
import styled from 'styled-components';
import withOpacity from '@shared/components/utils/hoc/withOpacity';

/**
 * Styled dial input.
 */
const DialInput = styled.span`
  background: ${Colors['dark']};
  border-radius: ${8 * Screen.widthRatio}px;
  color: ${Colors['text']};
  display: flex;
  font-family: ${Fonts['regular']};
  font-size: ${80 * Screen.widthRatio}px;
  left: ${116 * Screen.widthRatio}px;
  justify-content: start;
  min-width: ${180 * Screen.widthRatio}px;
  padding: ${8 * Screen.widthRatio}px;
  position: absolute;
  top: ${48 * Screen.widthRatio}px;
  z-index: 130; // Above the player, below the modal and ads and pause ad
`;

export default withOpacity(DialInput);
